// extracted by mini-css-extract-plugin
export var infoRow = "_qe-2";
export var labelContainer = "_qe-0";
export var rightInfo = "_qe-1";